import { GenericTabView } from "./tabs/generic-tab";
import { PanelTabsView } from "./panel-tabs";
import { IDocumentModel } from "./../interfaces/document-model";
import { backboneViewProperties } from "../../decorators/backbone-properties";

const dom = {
    FULLTEXT_SECTION_BUTTON: ".full-text-button",
    FULL_TEXT_DOCUMENT: ".full-text-document",
    FULLTEXT_LOADING: ".fulltext-loading",
    PARAGRAPH_GROUP: ".para-group",
    FULL_TEXT_CONTENT: ".full-text-content",
    SEARCH_TERM_PREV: ".search-term-up",
    SEARCH_TERM_NEXT: ".search-term-down",
    PARAGRAPH_STEPPERS: ".paragraph-step",
    PARAGRAPH_NUMBER_TEXT: ".txt-paragraph-number",
    CLEAR_FILTERS: ".clear-filters",
    FOOTNOTE_LINK: ".footnote-ref",
    FULLTEXT_NAV_LOADING: ".fulltext-nav-loading",
    FULL_TEXT_NAV: "ul.fulltext-nav"
};

@backboneViewProperties({
    childView: GenericTabView,
})
export class FullTextPanelView extends PanelTabsView {

    public constructor(private Data: IDocumentModel, options?: any) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/full-text-panel.ts